var _circle, _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_63)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5282 27.5C43.2225 22.8333 49.9582 22.8333 52.6525 27.5L67.8862 53.8855C70.5805 58.5522 67.2127 64.3855 61.8241 64.3855H31.3567C25.9681 64.3855 22.6002 58.5522 25.2945 53.8855L40.5282 27.5Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3475 30.8252C50.0418 26.1585 56.7776 26.1585 59.4719 30.8252L74.7056 57.2107C77.3999 61.8774 74.032 67.7107 68.6434 67.7107H38.176C32.7874 67.7107 29.4195 61.8774 32.1138 57.2107L47.3475 30.8252Z",
    fill: "url(#paint1_linear_1062_63)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3475 30.8252C50.0418 26.1585 56.7776 26.1585 59.4719 30.8252L74.7056 57.2107C77.3999 61.8774 74.032 67.7107 68.6434 67.7107H38.176C32.7874 67.7107 29.4195 61.8774 32.1138 57.2107L47.3475 30.8252Z",
    stroke: "url(#paint2_linear_1062_63)",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7126 39.4602C49.5516 40.1604 48.9976 41.0275 49 42.1395C49.0024 43.1374 50.9633 52.5533 51.2714 53.0468C51.5 53.4127 53.486 53.4318 53.7119 53.0703C54.0006 52.6077 56 42.9687 56 42.0385C56 39.7306 52.828 38.1838 50.7126 39.4602ZM50.9027 56.7051C50.5957 57.0912 50.3444 57.6961 50.3444 58.0495C50.3444 58.9666 51.4858 60 52.4989 60C53.5121 60 54.6534 58.9666 54.6534 58.0495C54.6534 56.9276 53.6799 56.003 52.4989 56.003C51.6983 56.003 51.3331 56.1634 50.9027 56.7051Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_63",
    x: 29.015,
    y: 25.1752,
    width: 48.7893,
    height: 44.6857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_63"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_63",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_63",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_63",
    x1: 28.5804,
    y1: 26.1544,
    x2: 96.7756,
    y2: 61.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_63",
    x1: 58.6748,
    y1: 30.8553,
    x2: 82.3675,
    y2: 86.1384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3ccfd054141bfe305661857a29d1097e.svg";
export { ForwardRef as ReactComponent };